import { Outlet, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import Sidebar from "./Sidebar";
import { DashboardProvider } from "../context/DashboardContext";

function AdminLayout() {
  const navigate = useNavigate();

  async function handleLogout() {
    await signOut(auth);
    navigate("/login", { replace: true });
  }

  return (
    <DashboardProvider>
      <div className="admin-shell">
        <Sidebar />

        <div className="admin-main">
          {/*<header className="admin-topbar">
            <div>
              <h1>Panel Admin</h1>
              <p>Gesti�n general de la aplicaci�n.</p>
            </div>

            <button className="logout-button" onClick={handleLogout}>
              Cerrar sesi�n
            </button>
          </header>*/}

          <main className="admin-content">
            <Outlet />
          </main>
        </div>
      </div>
    </DashboardProvider>
  );
}

export default AdminLayout;